import type { SDKPublicAPI } from '../../../lib/embed-contracts/public-types'
import { SDKInstance } from '../core/sdk-instance'

export function createSDK(): SDKPublicAPI {
  return new SDKInstance()
}